import {
  EPropertyType,
  type IPropertyType,
} from '@mahawi/eshop-common/src/types';
import { type RootState } from '@reducers';
import { Button, Col, Divider, Form, Row, Select, Space, Spin } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { updateType } from '../../reducers/property/reducer';
import { SPACING } from '../../theme/tokens';
import BubbleComponent from '../bubble';

interface IForm {
  type: EPropertyType;
}

function PropertyType(): React.ReactElement {
  const dispatch = useAppDispatch();
  const property = useSelector((s: RootState) => s.Property.property);
  const propertyInProcess = useSelector((s: RootState) => s.Property.inProcess);
  const propertiesTypes = useSelector((s: RootState) => s.Properties.types);

  const [form] = Form.useForm<IForm>();

  const [propertyTypesOptions, setPropertyTypesOptions] = useState<
    { value: string; label: string }[]
  >([]);

  const onFinish = useCallback(
    ({ type }: IForm): void => {
      if (property) {
        dispatch(updateType(property.code, type));
      }
    },
    [dispatch, property],
  );

  useEffect(() => {
    const propertyTypesOptionsUE: { value: string; label: string }[] =
      propertiesTypes.map((type: IPropertyType) => ({
        value: type.code,
        label: type.name,
      }));

    setPropertyTypesOptions(propertyTypesOptionsUE);
  }, [propertiesTypes]);

  useEffect(() => {
    if (property) {
      form.setFieldsValue({
        type: property.type,
      });
    }
  }, [form, property?.type, property, propertiesTypes]);

  return (
    <BubbleComponent span={8}>
      <Space size={SPACING.lg} align="start" orientation="horizontal">
        <strong>Type</strong>
      </Space>
      <Form form={form} onFinish={(values: IForm): void => onFinish(values)}>
        <Row>
          <Col xs={24} md={8}>
            <Space size={SPACING.lg} align="start">
              <Button
                type="primary"
                htmlType="submit"
                disabled={propertyInProcess}
              >
                Submit
              </Button>
              <Spin size="small" spinning={propertyInProcess} />
            </Space>
          </Col>
        </Row>

        <Divider />

        <Row>
          <Col span={24}>
            <Form.Item
              name="type"
              rules={[
                {
                  required: true,
                },
              ]}
              label="Type"
            >
              <Select size="large" options={propertyTypesOptions} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </BubbleComponent>
  );
}

export default PropertyType;
